import { EuiPageTemplate, EuiLoadingChart } from "@inscopix/ideas-eui";

export const CreatePersonalSpaceWaiting = () => {
  return (
    <EuiPageTemplate.EmptyPrompt
      title={<span>Setting things up...</span>}
      icon={<EuiLoadingChart size="xl" mono />}
    >
      This can take a few minutes.
    </EuiPageTemplate.EmptyPrompt>
  );
};
